import request from '@/CommonDP/utils/request';
import { isDef } from "@/CommonDP/utils/common";
import globalParams from "@/CommonDP/utils/globalParams";

export default {
  getQuestionSearchList(data) {
    return request.post(
      '/problem/manage/model/question-search-list',
      data
    );
  },
  getDrawingQuestionSearchList(prjId) {
    return request.get(
      `/drawing-annotation/getFilterConditions?prjId=${prjId}`
    );
  },
  // 模型
  getQuestionPageList(pageNo, pageSize, data) {
    return request.post(
      '/problem/manage/model/question-page-list?pageNo=' +
        pageNo +
        '&pageSize=' +
        pageSize,
      data
    );
  },
  // 图纸
  getDrawingQuestionPageList(data) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/drawing-annotation/list");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, data);
    }
    // return request.post('/drawing/question-page-list?pageNo='+pageNo+'&pageSize='+pageSize,data)
    return request.post('/drawing-annotation/list', data);
  },
  // getQuestionNodeList(prjId){
  //   return request.get(`/problem/manage/model/question-node-list?prjId=${prjId}`)
  //   .then(res => res)
  // },
  getQuestionDetails(qMId) {
    return request
      .get(`/problem/manage/model/question-details?qMId=${qMId}`)
      .then((res) => res);
  },
  getDrawingQuestionDetails(questionId) {
    return request
      .get(`/drawing-annotation/getById?id=${questionId}`)
      .then((res) => res);
  },
  getQuestionRecord(qMId) {
    return request
      .get(`/problem/manage/model/question-record?qMId=${qMId}`)
      .then((res) => res);
  },
  getDrawingQuestionRecord(id) {
    return request
      .get(`/drawing-annotation/getStatusUpdateRecordList?id=${id}`)
      .then((res) => res);
  },
  getCommentList(relaId, prjId) {
    return request
      .get(`/comment/list?relaId=${relaId}&prjId=${prjId}`)
      .then((res) => res);
  },
  createComment(data) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/comment/add");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, data);
    }
    return request.post('/comment/add', data);
  },
  QuestionDelete(qMId) {
    return request
      .get(`/problem/manage/model/question-delete?qMId=${qMId}`)
      .then((res) => res);
  },
  DrawingQuestionDelete(ids) {
    return request
      .post(`/drawing-annotation/delete`, ids)
      .then((res) => res);
  },
  QuestionExportExcel(data) {
    return request.post(
      '/problem/manage/model/question-export-excel',
      data
    );
  },
  DrawingQuestionExportExcel(data) {
    return request.post('/drawing/question-export-excel', data);
  },
  getIsExcelExist(params) {
    // 导出excel-是否能导出
    return request
      .get(`/problem/manage/is-excel-exist/${params}`)
      .then((res) => res);
  },
  queryDict(prjId) {
    // return request.get(`/common/dict/QueStatus?prjId=${prjId}`)
    return request
      .get(`/dic/content/list?dicCode=QueStatus&prjId=${prjId}`)
      .then((res) => res);
  },
  // drawing-annotation/dicList接口传fileId或者folderId都可以
  queryDict2(prjId, fileId) {
    // return request.get(`/common/dict/QueStatus?prjId=${prjId}`)
    return request
      .get(`/drawing-annotation/dicList?prjId=${prjId}&fileId=${fileId}`)
      .then((res) => res);
  },
  queryDict1(prjId, folderId) {
    // return request.get(`/common/dict/QueStatus?prjId=${prjId}`)
    return request
      .get(
        `/drawing-annotation/dicList?prjId=${prjId}&folderId=${folderId}`
      )
      .then((res) => res);
  },
  getDicList(prjId) {
    return request.get('/api/v1/drawing-annotation/dicList?prjId=' + prjId);
  },
  getFilterConditions(prjId) {
    // return request.get(`/common/dict/QueStatus?prjId=${prjId}`)
    return request
      .get(`/drawing-annotation/getFilterConditions?prjId=${prjId}`)
      .then((res) => res);
  },
  DrawingDicinit(prjId) {
    return request
      .get(`/drawing/dic-init?prjId=${prjId}`)
      .then((res) => res);
  },
  QuestionStatusBatchEdit(data) {
    return request.post(
      '/problem/manage/model/question-status-batch-edit',
      data
    );
  },
  DrawingQuestionStatusBatchEdit(data) {
    return request.post('/drawing-annotation/batchUpdateStatus', data);
  },
  Questionquesti(data) {
    return request.post(
      '/problem/manage/model/question-modifier-batch-edit',
      data
    );
  },
  DrawingQuestionquesti(data) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/drawing-annotation/updateModifier");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, data);
    }
    return request.post('/drawing-annotation/updateModifier', data);
  },
  getUserInfoListByPrjId(prjId) {
    return request
      .get(`/project/getProjectUsers?projectId=${prjId}`)
      .then((res) => res);
  },
  QuestionModifierList(data) {
    return request.post('/problem/manage/modifier-list', data);
  },
  QuestionChildItemList(data) {
    return request.post('/problem/manage/child-item-list', data);
  },
  QuestionEdit(data) {
    return request.post('/problem/manage/model/question-edit', data);
  },
  DrawingQuestionEdit(data) {
    return request.post('/lc/drawing-annotation/update', data);
  },
  recallComment(commentId) {
    return request
      .get(`/comment/delete/${commentId}`)
      .then((res) => res);
  },
  getQuestionNodeList(data) {
    return request
      .post(`/problem/manage/question-node-list`, data)
      .then((res) => res);
  },
  drawingDrawingQuesExport(params1) {
    return request({
      responseType: 'blob',
      url: '/drawing-annotation/export',
      method: 'post',
      data: params1
    });
  },
  drawingannotationupdateStatus(data) {
    return request.post('/drawing-annotation/updateStatus', data);
  },
  batchUpdatecount(data) {
    return request.post('/drawing-annotation/batchUpdate/count', data);
  }
};
